import { render } from "./FloatingMessageWidget.vue?vue&type=template&id=3f1d3a63&scoped=true"
import script from "./FloatingMessageWidget.vue?vue&type=script&lang=js"
export * from "./FloatingMessageWidget.vue?vue&type=script&lang=js"

import "./FloatingMessageWidget.vue?vue&type=style&index=0&id=3f1d3a63&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1d3a63"]])

export default __exports__